import React from "react";
import ResourceViewer from "./ResourceViewer";
import video1 from "../../public/media/videos/Video1.mp4";


export default function VideoTutorial() {
  return (
    <ResourceViewer
      title="Video Tutorial"
      description="Watch this tutorial to learn how to use the LIMS platform."
      type="video"
      file={video1}
    />
  );
}